"use client";

import React, {useState} from "react";
import {InlineText} from "@/components/content/common/InlineText";

export const NOTIFICATION_DESCRIPTION_PREVIEW_LENGTH = 150;

export function truncateNotificationDescription(
    description: string,
    maximumLength = NOTIFICATION_DESCRIPTION_PREVIEW_LENGTH,
) {
    if (description.length <= maximumLength) {
        return description;
    }

    const preview = description.slice(0, maximumLength + 1);
    const wordBoundary = preview.search(/\s+\S*$/);

    if (wordBoundary > 0) {
        return `${preview.slice(0, wordBoundary).trimEnd()}…`;
    }

    const nextBoundary = description.slice(maximumLength).search(/\s/);
    if (nextBoundary >= 0) {
        return `${description.slice(0, maximumLength + nextBoundary).trimEnd()}…`;
    }

    return description;
}

export function NotificationDescription({
    description,
    showMoreLabel,
    showLessLabel,
}: {
    description: string;
    showMoreLabel: string;
    showLessLabel: string;
}) {
    const [expanded, setExpanded] = useState(false);
    const preview = truncateNotificationDescription(description);
    const canExpand = preview !== description;

    return (
        <p className="mt-1 text-sm leading-relaxed text-zinc-600">
            <InlineText value={expanded ? description : preview} />
            {canExpand && (
                <button
                    type="button"
                    onClick={() => setExpanded((value) => !value)}
                    className="ml-1 inline text-inherit underline decoration-current underline-offset-2 hover:no-underline focus-visible:rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current"
                >
                    {expanded ? showLessLabel : showMoreLabel}
                </button>
            )}
        </p>
    );
}
